define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/heading/AttributeController",
	"csi/locale",
	"csi/widget/CommentDialog"
], function(declare,lang,AttributeController,locale,CommentDialog) {

	return declare(AttributeController, {
		csiDialog: null,

		getTitle: function() {
			return locale.resource('StringRichAttribute_Title',[this.heading.m_name]);
		},

		preProcess: function() {
			// summary: open Comments dialog.
			this.setProgress();
			
			this.csiDialog = new CommentDialog({
				csiRefNode: this.m_element,
				title: this.getTitle(),
				value: {text: this.oldValue},
				onSave: lang.hitch(this, this._onSave),
				onCancel: lang.hitch(this, this._onCancel)
			});
			this.csiDialog.startup();
			this.csiDialog.show();
			
			this.setProgress(null);
		},

		postProcess: function(/*Boolean*/bStatus, /*Boolean*/bRepeat) {
			// summary: close the dialog
			if (this.csiDialog) {
				this.csiDialog.hide();
			}

			this.inherited(arguments);
		},

		_onSave: function(/*Object*/value) {
			this.newValue = value && value.text || "";
			this.process();
		},

		_onCancel: function() {
			this.postProcess();
		}
	});
});
